import {BaseAnimation} from "./base-animation";

export class AutoAnimation extends BaseAnimation {
  start() {
    setTimeout(() => this.enter(), this.delayMS);
  }

  enter() {
    super.enter();
    setTimeout(() => this.main(), this.enterDurationMS);
  }

  main() {
    super.main();
    setTimeout(() => this.leave(), this.mainDurationMS);
  }

  leave() {
    super.leave();
    setTimeout(() => this.stop(), this.leaveDurationMS);
  }
}
